import { getScopes } from '../../selectors/userSelectors/getScopes';
export const getHasCapacityLimitsAccess = state => {
  const scopes = getScopes(state);
  return scopes.includes('capacity-limits-access') && scopes.includes('conversations-routing');
};